// WizCase's [youtube-embed]: the video's still until it is clicked, then the player
document.querySelectorAll('.youtube-embed--facade').forEach(embed => {
    embed.querySelector('.youtube-embed__still').addEventListener('click', event => {
        event.preventDefault();

        const iframe = document.createElement('iframe');

        iframe.src = embed.dataset.youtubeSrc;
        iframe.title = embed.dataset.title;
        iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        //YouTube refuses to play an embed without a Referer (error 153), and the site sends `Referrer-Policy: no-referrer`
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        embed.replaceChildren(iframe);
    }, {once: true});
});
